import { MainContainer, ProfileContainerInfo, Label, ShowInput, TextArea, Span, ButtonContainer, StyledSelect, StyledButtonConfirmar, StyledButtonVoltar, LeftColumn, RightColumn, Row, FormContainer, ArquivoAtual, ArquivoEscolhido, FileInputButton, HiddenFileInput, StyledAddArea, FileInputWrapper, Title } from "./styles";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { appStatus } from "../../store/modules/app_status/actions";
import { storeOwnerId } from "../../store/modules/app_data/actions";
import { CardCheckbox } from './CheckBox/CheckBox';
import { motion } from "framer-motion";
import Swal from "sweetalert2";
import { useForm, Controller } from "react-hook-form";
import { useHookFormMask } from "use-mask-input";
import { zodResolver } from "@hookform/resolvers/zod";
import { ErrorForm } from "../inter_register_user/ErrorForm";
import { registerProjectSchema } from "./registerProjectValidation";
import { userService } from "../../services/userService";
import { projectService } from "../../services/projectService";
import CreateArea from "../guardian/CreateArea";
import { isAdminOrEngineeringUser } from "../../utils/userRoles";

function normalizeUsersPayload(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.users)) return payload.users;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

const RegisterProjectInfo = ({ newOwner }) => {
  const navigate = useNavigate();
  const [isCpf, setIsCpf] = useState(true);
  const [users, setUsers] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [owner, setOwner] = useState(newOwner?.id ?? currentUser?.id ?? null);
  const [selectedCards, setSelectedCards] = useState([]);
  const dispatch = useDispatch();
  const [project, setProject] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [areas, setAreas] = useState([]);
  const [savedAreas, setSavedAreas] = useState([]);
  const [areaCounter, setAreaCounter] = useState(1);
  const [emailVerified, setEmailVerified] = useState(false);
  const [emailCheckInProgress, setEmailCheckInProgress] = useState(false);
  const [existingUserData, setExistingUserData] = useState(null);

  const errorTranslations = {
    "This password is too short. It must contain at least 8 characters.": "A senha é muito curta. Deve conter pelo menos 8 caracteres.",
    "This password is too common.": "Esta senha é muito comum.",
    "This password is entirely numeric.": "A senha não pode ser composta apenas por números.",
    "This field may not be blank.": "Este campo não pode estar em branco.",
    "This field is required.": "Este campo é obrigatório.",
    "Enter a valid email address.": "Informe um endereço de e-mail válido.",
    "A user with that email already exists.": "Já existe um usuário com este e-mail.",
    "Já existe um usuário cadastrado com este email.": "Já existe um usuário cadastrado com este e-mail.",
  };

  const fieldNames = {
    title: "Nome da propriedade",
    address: "Endereço",
    conservation_unit: "Unidade de Conservação",
    legal_reserve_deficit: "Déficit de reserva legal",
    has_federal_debt: "Dívida federal",
    project_owner: "Proprietário",
    email: "E-mail",
    name: "Nome",
    phone: "Telefone",
    cpf: "CPF",
    cnpj: "CNPJ",
    person_type: "Tipo de pessoa",
    password: "Senha",
    non_field_errors: "Erro geral",
  };

  const translateError = (msg) => errorTranslations[msg] || msg;

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    setValue,
    watch,
    reset
  } = useForm({
    resolver: zodResolver(registerProjectSchema),
  });

  const ownerEmail = watch("project_owner.email");

  const [expandedAreas, setExpandedAreas] = useState({});

  const handleToggleExpand = (areaId, isExpanded) => {
    setExpandedAreas(prev => ({
      ...prev,
      [areaId]: isExpanded
    }));
  };

  const registerWithMask = useHookFormMask(register);

  const handleEntityChange = (e) => {
    const value = e.target.value;
    setIsCpf(value === "Física");
  };

  const handleCardSelection = (newSelection) => {
    setSelectedCards(newSelection);
  };

  const checkEmailExists = async (email) => {
    if (!email || email.length < 5) return;

    setEmailCheckInProgress(true);

    try {
      const response = await userService.checkEmailExists(email);

      if (response.exists) {
        const result = await Swal.fire({
          title: "Email já cadastrado",
          text: `Já existe um usuário com o email "${email}". Deseja prosseguir com as informações deste usuário?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim, usar estas informações",
          cancelButtonText: "Não, usar outro email",
          reverseButtons: true,
          allowOutsideClick: false
        });

        if (result.isConfirmed) {
          setExistingUserData(response.user);
          setValue("project_owner.name", response.user.full_name || response.user.name || "");
          setValue("project_owner.phone", response.user.phone || "");
          setValue("project_owner.cpf", response.user.cpf || "");
          setValue("project_owner.cnpj", response.user.cnpj || "");

          if (response.user.cnpj) {
            setValue("project_owner.person_type", "Jurídica");
            setIsCpf(false);
          } else if (response.user.cpf) {
            setValue("project_owner.person_type", "Física");
            setIsCpf(true);
          }

          setEmailVerified(true);

          Swal.fire({
            title: "Informações carregadas",
            text: "Os dados do usuário existente foram carregados. Você pode editá-los se necessário.",
            icon: "info",
            confirmButtonText: "OK"
          });
        } else {
          setValue("project_owner.name", "");
          setValue("project_owner.email", "");
          setValue("project_owner.phone", "");
          setValue("project_owner.cpf", "");
          setValue("project_owner.cnpj", "");
          setValue("project_owner.person_type", "Física");
          setIsCpf(true);
          setEmailVerified(false);
          setExistingUserData(null);

          setTimeout(() => {
            document.getElementById("email")?.focus();
          }, 100);
        }
      } else {
        setEmailVerified(true);
        setExistingUserData(null);
      }
    } catch (error) {
      setEmailVerified(true);
    } finally {
      setEmailCheckInProgress(false);
    }
  };

  useEffect(() => {
    if (ownerEmail && ownerEmail.includes("@") && !emailVerified) {
      const timer = setTimeout(() => {
        checkEmailExists(ownerEmail);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [ownerEmail]);

  const handleAddArea = () => {
    const newAreaId = Date.now();
    const newAreaNumber = areaCounter;

    setAreas(prev => [
      ...prev,
      {
        id: newAreaId,
        number: newAreaNumber,
        saved: false
      }
    ]);

    setAreaCounter(prev => prev + 1);
  };

  const handleAreaSave = (areaId, areaData) => {
    const areaToSave = {
      ...areaData,
      id: areaId,
      saved: true,
      originalFormData: areaData.formData || null,
      ...(areaData.formData ? {} : areaData)
    };

    setAreas(prev => prev.map(area =>
      area.id === areaId
        ? {
          ...area,
          ...areaToSave,
          number: area.number || areaToSave.number || areaToSave.areaNumber
        }
        : area
    ));

    setSavedAreas(prev => {
      const filtered = prev.filter(area => area.id !== areaId);
      return [...filtered, areaToSave];
    });
  };

  const handleClick = async () => {
    try {
      dispatch(appStatus("Projetos"));
      navigate("/welcome", { replace: true });
    } catch (err) {
      console.error("Erro ao mudar de página:", err);
    }
  };

  useEffect(() => {
    dispatch(storeOwnerId(owner));

    const fetchUsers = async () => {
      try {
        const usersRes = await userService.getUsers();
        setUsers(normalizeUsersPayload(usersRes));
      } catch (error) {
        console.error("Erro ao buscar usuários:", error);
      }
    };

    fetchUsers();

    if (!isAdminOrEngineeringUser(currentUser) && currentUser?.id) {
      setOwner(currentUser.id);
    }
  }, [owner, currentUser, dispatch]);

  const propUsers = (Array.isArray(users) ? users : [])
    .filter((user) => user?.user_type === "PROP" && user?.email)
    .slice()
    .sort((a, b) => {
      const nameA = (a.full_name || a.name || a.email || "").toLowerCase();
      const nameB = (b.full_name || b.name || b.email || "").toLowerCase();
      return nameA.localeCompare(nameB, "pt-BR");
    });

  const applyPropOwner = (email) => {
    const selected = propUsers.find(
      (user) => (user.email || "").toLowerCase() === (email || "").toLowerCase()
    );

    if (!selected) {
      setExistingUserData(null);
      setEmailVerified(false);
      return;
    }

    setExistingUserData(selected);
    setValue("project_owner.name", selected.full_name || selected.name || "");
    setValue("project_owner.phone", selected.phone || "");
    setValue("project_owner.cpf", selected.cpf || "");
    setValue("project_owner.cnpj", selected.cnpj || "");

    if (selected.cnpj) {
      setValue("project_owner.person_type", "Jurídica");
      setIsCpf(false);
    } else {
      setValue("project_owner.person_type", "Física");
      setIsCpf(true);
    }

    setEmailVerified(true);
  };

  const cleanNumber = (val) => {
    if (!val) return null;
    return parseFloat(val.replace(/\./g, "").replace(",", "."));
  };

  const handleFileInput = (fieldName, event, onChange) => {
    const file = event.target?.files?.[0];

    if (!file) return;

    const allowedExtensions = ["jpg", "jpeg", "png"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      alert("Formato não permitido. Use apenas JPG, JPEG ou PNG.");
      event.target.value = "";
      return;
    }

    setSelectedFiles((prev) => ({ ...prev, [fieldName]: file }));

    if (onChange) {
      onChange(file);
    }
  };

  async function handleRegister(data) {
    if (!emailVerified && ownerEmail) {
      const result = await Swal.fire({
        title: "Verificar email",
        text: "Você ainda não verificou se este email já está cadastrado. Deseja verificar agora?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, verificar",
        cancelButtonText: "Não, continuar sem verificar"
      });

      if (result.isConfirmed) {
        await checkEmailExists(ownerEmail);
        return;
      }
    }

    setIsSubmitting(true);

    const usuarioId = sessionStorage.getItem("usuario_id");
    const formData = new FormData();

    Object.entries(selectedFiles).forEach(([key, file]) => {
      if (file) formData.append(key, file);
    });

    Object.entries(data).forEach(([key, value]) => {
      if (key in selectedFiles) return;

      if (["total_area", "legal_reserve_area", "legal_reserve_deficit"].includes(key)) {
        formData.append(key, cleanNumber(value) || "");
      } else if (key === "project_owner") {
        formData.append("project_owner", JSON.stringify(value));
      } else {
        formData.append(key, value ?? "");
      }
    });

    formData.append("usuario_id", usuarioId);

    if (existingUserData) {
      formData.append("use_existing_user", "true");
      formData.append("existing_user_id", existingUserData.id);
    } else {
      formData.append("use_existing_user", "false");
    }

    savedAreas.forEach((area, index) => {
      const hasFormData = area.originalFormData && area.originalFormData instanceof FormData;
      const hasDirectData = area.name || area.vert_responsible;

      if (hasFormData) {
        for (let pair of area.originalFormData.entries()) {
          const [key, value] = pair;
          if (!(value instanceof File)) {
            formData.append(`areas[${index}][${key}]`, value);
          }
        }
      } else if (hasDirectData) {
        formData.append(`areas[${index}][name]`, area.name || `Área ${area.areaNumber || area.number || (index + 1)}`);
        formData.append(`areas[${index}][area_number]`, area.areaNumber || area.number || (index + 1));

        const areaFields = [
          'vert_responsible',
          'adi_responsible',
          'total_area',
          'legal_reserve_area',
          'matricula_status',
          'reserve_legal_status',
          'georeferencing_status',
          'sicar_code',
          'status_car'
        ];

        areaFields.forEach(field => {
          if (area[field] !== undefined && area[field] !== null) {
            formData.append(`areas[${index}][${field}]`, area[field]);
          }
        });

        if (area.other_responsibles && Array.isArray(area.other_responsibles)) {
          area.other_responsibles.forEach((responsible, respIndex) => {
            if (responsible) {
              formData.append(`areas[${index}][other_responsibles][${respIndex}]`, responsible);
            }
          });
        }

        if (area.adi_image && area.adi_image instanceof File) {
          formData.append(`areas[${index}][adi_image]`, area.adi_image);
        }
      }
    });

    try {
      const response = await projectService.createCompleteProject(formData);
      const responseData = response;

      let projectId = null;

      if (responseData.project_id) {
        projectId = responseData.project_id;
      } else if (responseData.project?.id) {
        projectId = responseData.project.id;
      } else if (responseData.id) {
        projectId = responseData.id;
      }

      if (!projectId && responseData.project && typeof responseData.project === 'object') {
        projectId = responseData.project.id || responseData.project.project_id;
      }

      if (projectId) {
        if (selectedCards && selectedCards.length > 0) {
          try {
            await projectService.postSdgsByProject(projectId, selectedCards);
          } catch (odsError) {
            Swal.fire({
              title: "Atenção",
              text: "Projeto criado, mas houve um erro ao salvar os ODS. Você pode editá-los posteriormente.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }

        await Swal.fire({
          title: "Sucesso!",
          html: `
            <div style="text-align: left;">
              <p><strong>Projeto criado com sucesso!</strong></p>
              <p>Áreas criadas: ${responseData.areas_created_successfully || responseData.created_areas?.length || 0}</p>
              ${responseData.failed_areas?.length > 0
              ? `<p><strong>Atenção:</strong> ${responseData.failed_areas.length} área(s) não foram criadas.</p>`
              : ''}
            </div>
          `,
          icon: "success",
          confirmButtonText: "OK",
        });

        await handleClick();
      } else {
        await Swal.fire({
          title: "Atenção",
          html: `
            <div style="text-align: left;">
              <p><strong>Projeto parece ter sido criado, mas houve um problema com a resposta.</strong></p>
              <p>Por favor, verifique na lista de projetos se ele foi criado.</p>
            </div>
          `,
          icon: "warning",
          confirmButtonText: "OK",
        });

        await handleClick();
      }

    } catch (err) {
      const errorData = err.response?.data;
      let errorMessage = "Algo deu errado ao tentar processar sua requisição.";

      if (errorData && typeof errorData === "object") {
        const messages = Object.entries(errorData)
          .map(([field, errors]) => {
            const label = fieldNames[field] || field;
            const fieldErrors = Array.isArray(errors)
              ? errors.map(translateError).join("<br/>• ")
              : translateError(String(errors));
            return `<b>${label}:</b><br/>• ${fieldErrors}`;
          })
          .join("<br/><br/>");

        if (messages) errorMessage = messages;
      } else if (err.request) {
        errorMessage = "Sem resposta do servidor. Verifique sua conexão.";
      } else if (err.message) {
        errorMessage = translateError(err.message);
      }

      await Swal.fire({
        title: "Erro ao cadastrar!",
        html: `<div style="text-align: left; font-size: 14px; line-height: 1.8">${errorMessage}</div>`,
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "var(--danger)",
      });
    }
  }

  const handleRemoveArea = (areaId) => {
    setAreas(prev => prev.filter(area => area.id !== areaId));
    setSavedAreas(prev => prev.filter(area => area.id !== areaId));
  };

  return (
    <MainContainer>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8 }}
      >
        <ProfileContainerInfo>
          <Title>Informações Cadastrais</Title>
          <FormContainer>
            <LeftColumn>
              <Row>
                <Label>
                  Qual o nome (fantasia) da sua terra, fazenda ou reserva?
                </Label>
                <ShowInput
                  type="text"
                  id="title"
                  {...register("title")}
                  placeholder="Ex: Fazenda Santa Júlia"
                />
                <ErrorForm message={errors.title?.message} />
              </Row>

              <Row>
                <Label>Qual o endereço da propriedade?</Label>
                <ShowInput
                  type="text"
                  id="address"
                  placeholder="Ex: Estrada Rural 45, KM 12, Zona Rural - Município/UF"
                  {...register("address")} />
                <ErrorForm message={errors.address?.message} />
              </Row>

              <Row>
                <Label>Possui Unidade de Conservação (UC) no imóvel?</Label>
                <StyledSelect
                  id="conservation_unit"
                  defaultValue=""
                  {...register("conservation_unit")}
                >
                  <option value="" disabled>Selecione uma opção</option>
                  <option value="Privada">Privada</option>
                  <option value="Pública">Pública</option>
                  <option value="Não possui">Não possui</option>
                </StyledSelect>
                <ErrorForm message={errors.conservation_unit?.message} />
              </Row>

              <Row>
                <Label>Possui déficit de reserva legal?</Label>
                <StyledSelect
                  id="legal_reserve_deficit"
                  defaultValue=""
                  {...register("legal_reserve_deficit")}
                >
                  <option value="" disabled>Selecione uma opção</option>
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </StyledSelect>
                <ErrorForm message={errors.legal_reserve_deficit?.message} />
              </Row>

              <Row>
                <Label>Possui dívida federal pelo não pagamento de tributos?</Label>
                <StyledSelect
                  id="has_federal_debt"
                  defaultValue=""
                  {...register("has_federal_debt")}
                >
                  <option value="" disabled>Selecione uma opção</option>
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </StyledSelect>
                <ErrorForm message={errors.has_federal_debt?.message} />
              </Row>
            </LeftColumn>

            <RightColumn>
              <Row>
                <Label>Nome completo do proprietário</Label>
                <ShowInput
                  type="text"
                  id="name"
                  {...register("project_owner.name")}
                  placeholder="Ex: João da Silva"
                  disabled={existingUserData && emailVerified}
                />
                <ErrorForm message={errors.project_owner?.name?.message} />
              </Row>

              <Row>
                <Label>Email do proprietário</Label>
                <StyledSelect
                  id="email"
                  {...register("project_owner.email", {
                    onChange: (e) => applyPropOwner(e.target.value),
                  })}
                  disabled={emailCheckInProgress}
                >
                  <option value="">Selecione um usuário</option>
                  {propUsers.map((user) => (
                    <option key={user.id} value={user.email}>
                      {(user.full_name || user.name || "Sem nome") + " — " + user.email}
                    </option>
                  ))}
                </StyledSelect>
                {propUsers.length === 0 && (
                  <small style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>
                    Nenhum usuário do tipo PROP encontrado no sistema.
                  </small>
                )}
                <ErrorForm message={errors.project_owner?.email?.message} />
              </Row>

              <Row>
                <Label>Telefone do proprietário</Label>
                <ShowInput
                  type="text"
                  id="phone"
                  {...registerWithMask("project_owner.phone", "(99) 99999-9999")}
                  placeholder="(11) 99999-9999"
                  disabled={existingUserData && emailVerified}
                />
                <ErrorForm message={errors.project_owner?.phone?.message} />
              </Row>

              <Row>
                <Label>Qual o tipo de titular (pessoa) do imóvel?</Label>
                <StyledSelect
                  id="person_type"
                  {...register("project_owner.person_type", {
                    onChange: (e) => handleEntityChange(e)   // 👈 aqui dentro
                  })}
                  disabled={existingUserData && emailVerified}
                >
                  <option value="">Selecione uma opção</option>
                  <option value="Física">Física</option>
                  <option value="Jurídica">Jurídica</option>
                </StyledSelect>
                <ErrorForm message={errors.project_owner?.person_type?.message} />
              </Row>

              <Row>
                <Label>{isCpf ? "CPF" : "CNPJ"} do proprietário</Label>
                <ShowInput
                  type="text"
                  id={isCpf ? "cpf" : "cnpj"}
                  {...registerWithMask(
                    isCpf ? "project_owner.cpf" : "project_owner.cnpj",
                    isCpf ? "999.999.999-99" : "99.999.999/9999-99"
                  )}
                  placeholder={isCpf ? "Digite o CPF" : "Digite o CNPJ"}
                  disabled={existingUserData && emailVerified}
                />
                <ErrorForm
                  message={
                    isCpf
                      ? errors.project_owner?.cpf?.message
                      : errors.project_owner?.cnpj?.message
                  }
                />
              </Row>
            </RightColumn>

            <CardCheckbox
              initialSelection={selectedCards}
              onSelectionChange={handleCardSelection}
            />

            <Row>
              <Label>Imagem Representativa do Projeto</Label>
              {project?.project_image && (
                <ArquivoAtual>
                  Arquivo atual:{" "}
                  {typeof project.project_image === "string"
                    ? project.project_image.split("/").pop()
                    : "Arquivo carregado"}
                </ArquivoAtual>
              )}
              {selectedFiles?.project_image && (
                <ArquivoEscolhido>
                  Arquivo selecionado: {selectedFiles.project_image.name}
                </ArquivoEscolhido>
              )}
              <Controller
                name="project_image"
                control={control}
                render={({ field }) => (
                  <FileInputWrapper>
                    <FileInputButton htmlFor="file-input-project-image">
                      Selecionar Arquivo
                    </FileInputButton>
                    <HiddenFileInput
                      id="file-input-project-image"
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      onChange={(e) => handleFileInput("project_image", e, field.onChange)}
                    />
                  </FileInputWrapper>
                )}
              />
            </Row>

            <Label>
              Existem ações tomadas pelo proprietário para garantir a
              preservação das florestas existentes no imóvel?
            </Label>
            <Span>
              Descrever abaixo quais são essas ações e a data em que foram realizadas.
            </Span>
            <Span>
              Estas ações podem ser in loco, tal como cercamento ou aceiro, ou
              pode ser uma ação legal, tal como averbação da reserva legal na
              matrícula ou criação de uma RPPN.
            </Span>
            <p />
            <TextArea
              type="text"
              id="owner_actions_to_preserve_forest"
              {...register("owner_actions_to_preserve_forest")}
            />
            <ErrorForm message={errors.owner_actions_to_preserve_forest?.message} />
          </FormContainer>
        </ProfileContainerInfo>

        <ButtonContainer>
          <StyledAddArea type="button" onClick={handleAddArea}>
            Adicionar área
          </StyledAddArea>
        </ButtonContainer>

        {areas.map((area) => (
          <ProfileContainerInfo key={area.id} isExpanded={area.isExpanded}>
            <Title>Informações da área {area.number}</Title>
            <CreateArea
              areaNumber={area.number}
              onAreaChange={(areaId, areaData) => handleAreaSave(areaId, areaData)}
              onRemove={() => handleRemoveArea(area.id)}
              onToggleExpand={(expanded) => handleToggleExpand(area.id, expanded)}
            />
          </ProfileContainerInfo>
        ))}

        <ButtonContainer>
          <StyledButtonConfirmar
            onClick={() => {
              const errorCount = Object.keys(errors).length;

              if (errorCount > 0) {
                Swal.fire({
                  title: "Erros no Formulário",
                  html: `
                    <div style="text-align: left;">
                      <p>Por favor, corrija os seguintes erros:</p>
                      <ul>
                        ${Object.entries(errors).slice(0, 5).map(([key, error]) =>
                    `<li><strong>${key}:</strong> ${error?.message || 'Erro não especificado'}</li>`
                  ).join('')}
                        ${errorCount > 5 ? `<li>... e mais ${errorCount - 5} erros</li>` : ''}
                      </ul>
                    </div>
                  `,
                  icon: "error",
                  confirmButtonText: "OK",
                });
                return;
              }

              if (ownerEmail && !emailVerified && !emailCheckInProgress) {
                Swal.fire({
                  title: "Verificar email",
                  text: "Por favor, termine de digitar o email e aguarde a verificação automática, ou clique fora do campo para verificar.",
                  icon: "warning",
                  confirmButtonText: "OK",
                });
                return;
              }

              try {
                handleSubmit((data) => {
                  handleRegister(data);
                })();
              } catch (error) {
                console.error('Erro ao chamar handleSubmit:', error);
              }
            }}
            type="button"
            disabled={isSubmitting || emailCheckInProgress}
          >
            {isSubmitting ? 'Enviando...' :
              emailCheckInProgress ? 'Verificando email...' : 'Confirmar'}
          </StyledButtonConfirmar>
          <StyledButtonVoltar type="button" onClick={handleClick}>
            Voltar
          </StyledButtonVoltar>
        </ButtonContainer>
      </motion.div>
    </MainContainer>
  );
};

export default RegisterProjectInfo;